import { tState } from "@src/Model/Model"
import { isAfter, parseISO, startOfDay } from "date-fns"
import { createSelector } from "reselect"

const zimmGlossarySelector = (state: tState) => state.zimm.getConfig.glossary

export const glossarySelector = createSelector(
  zimmGlossarySelector,
  (glossary) => {
    return Object.keys(glossary).reduce((acc: Record<string, string>, key) => {
      acc[key.toLowerCase()] = glossary[key]
      return acc
    }, {})
  },
)

const plans = (state: tState) => state.plans

export const hasTrialPlanExpiredSelector = createSelector(plans, (plans) => {
  return (
    isAfter(
      startOfDay(new Date()),
      startOfDay(parseISO(plans.expirationDate)),
    ) && plans.subscriptionStatus === "INTRIAL"
  )
})

const globalModalsSelector = (state: tState) =>
  state.globalModals.globalModalState

export const isAnyOfGlobalModalIsActiveSelector = createSelector(
  globalModalsSelector,
  (globalModals) => {
    return Object.values(globalModals).some((value) => value === true)
  },
)
